<script lang="ts" setup>
import ArrowBtn from '~/design/components/buttons/arrow-btn.vue';
import SectionTemplate from '~/design/widgets/landing-section/cn-template.vue';
import VideoCarousel from './video-carousel.vue';

withDefaults(defineProps<{ autoplay?: boolean }>(), {
  autoplay: true,
});

const infos = [
  {
    title: '创建作品',
    tabDesc: '4种方式创建作品',
    url: getFeUrl('/youyan-platform/character-intro/create-like-pro/1.webm'),
    poster: getFeUrl('/youyan-platform/character-intro/create-like-pro/1.png'),
  },
  {
    title: '选择人物和场景',
    tabDesc: '选择想要使用的场景和人物',
    url: getFeUrl('/youyan-platform/character-intro/create-like-pro/2.webm'),
    poster: getFeUrl('/youyan-platform/character-intro/create-like-pro/2.png'),
  },
  {
    title: '输入脚本',
    tabDesc: '输入你的脚本，也可使用AI帮助你创作',
    url: getFeUrl('/youyan-platform/character-intro/create-like-pro/3.webm'),
    poster: getFeUrl('/youyan-platform/character-intro/create-like-pro/3.png'),
  },
  {
    title: '3D生成',
    tabDesc: '点击3D生成，即可获得高品质视频',
    url: getFeUrl('/youyan-platform/character-intro/create-like-pro/4.webm'),
    poster: getFeUrl('/youyan-platform/character-intro/create-like-pro/4.png'),
  },
];

const activeIndex = ref(0);
const src = ref(infos[activeIndex.value].url);
const poster = ref(infos[activeIndex.value].poster);

watch(
  () => activeIndex.value,
  val => {
    src.value = infos[val].url;
    poster.value = infos[val].poster;
  },
);
</script>

<template>
  <SectionTemplate
    class="section-product-operation"
    data-buried="CreateLikeAPro"
    title="无需拍摄剪辑，用AI数字人轻松高效做出专业级视频"
    subTitle="产品操作"
  >
    <VideoCarousel class="carousel" :infos="infos" :autoplay="autoplay" />
    <ArrowBtn
      text="免费试用"
      variant="black-common"
      class="section-product-operation__button"
      type="small"
      @click="$emit('handle-trail')"
    />
  </SectionTemplate>
</template>

<style lang="scss" src="./styles/mobile.scss" scoped />
<style lang="scss" src="./styles/pc.scss" scoped />
